"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0; // @ts-check

/**
 * @returns {object}
 */

var renderNothing = function renderNothing()
/* props */
{
  // eslint-disable-next-line
  throw null;
};

var _default = renderNothing;
exports.default = _default;